import styled from 'styled-components';

export const SignUpSection = styled.div`
    background: #F1FEFF;
    padding: 30px 8px;
     height: 100vh; 
    display: flex; 
    align-items: center;  
  
  @media screen and (max-width:1366px) { 
      height:100%;
         padding: 50px 8px;
   }
    @media screen and (max-width:1199px) { 
        flex-wrap: wrap; 
        height: 100vh;
     } 
     @media screen and (max-width:767px) { 
        .signUp-col{
        flex-wrap: wrap-reverse;
        gap: 30px;
            }
    }  
    
`;
export const SignUpLeftPart = styled.div`
   @media screen and (max-width:767px) { 
    border-top: 1px dashed;
    padding-top: 35px;
}
&.sing-up-mb-new{
    h1{
        display:none;
    }
}
`;
export const SignUpRightPart = styled.div`

`;
export const BackToHomeBtn = styled.div`
    margin-bottom: 30px;
      @media screen and (max-width:1366px) {
          margin-bottom: 20px;
      }
    
    @media screen and (max-width:767px) {
        margin-bottom:10px;
        margin-top:20px;
    }
    .back-btn{
        padding: 0;
        background: transparent;
        border: none;
        display: flex;
        align-items: center;
        gap: 5px;
        justify-content: center;
        color: #333333;
        font-family: "Jost", sans-serif;
        font-size: 14px;
        font-weight:600;
        line-height: 24px;
        width:100%;
   &:active{
        background: transparent;
        border: none;
        color: #333333;
   }
        img{
            width: 20px;
            height: 100%;
            transform: rotate(90deg);
            margin-top: 1px;
        }
    }
`;
export const GreatNonProfitsImg = styled.div`
    text-align: center;
    margin-bottom: 30px;
    @media screen and (max-width:767px) {
        margin-bottom: 10px;
    }
    img{
        width: 100%;
        @media screen and (max-width:767px) {
            max-width:250px;
        }
    }
`;
export const UserCreateTitle = styled.div`
    text-align: center;
    margin-bottom: 30px;
    @media screen and (max-width:767px) {
        margin-bottom: 10px;
    }
`;
export const FormTitle = styled.h2`
    color: #33A7AE;
    font-family: "Jost", sans-serif;
    font-size: 30px;
    font-weight: 800;
    line-height: 43px;
    text-transform: capitalize;
    @media screen and (max-width:991px) {
        font-size: 25px;
        line-height: 30px;
    }
    @media screen and (max-width:767px) {
        font-size: 20px;
        line-height: 30px;
    }
`;

export const TabViewForm = styled.div`
    .nav-tabs {
        justify-content: center;
        margin-bottom: 20px;
        border: none;

        li.nav-item {
            background: #33A7AE;
            padding: 5px;
            
            &:first-child {
                border-radius: 8px 0px 0px 8px;
            }
            &:last-child {
                border-radius: 0px 8px 8px 0px;
                    .nav-link{
                 &:after{
                      display:none;
                      }
                  
              }
            }

            .nav-link{
                font-family: "Jost", sans-serif;
                color: #FFFFFF;
                font-size: 14px;
                font-weight: 500;
                line-height: 24px;
                border: none;
               border-radius: 4px;
                   position: relative;
                //    &:after{
                //    position: absolute;
                //     width: 1px;
                //     height: 46px;
                //     content: "";
                //     background:#01606F;
                //     right: 0;
                //     top: 0;}
                &:hover, &.active {
                    background: #01606F;
                    border: none;
                     color: #FFFFFF;
                }
            }
        }
    }
    .sign-up-form{
        max-width: 540px;
        margin: 0 auto;
    }
`;
export const PrivacyText = styled.p`
    color: #555555;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    margin: 0;
    @media screen and (max-width:767px) { 
        font-size: 12px;
        line-height: 15px;
    }
    .btn{
        padding: 0;
        background: transparent;
        border: none;
        color: #016B7B;
        font-size: inherit;
        line-height: inherit;
        vertical-align: inherit;
        margin: 0;
      &:active{
        background: transparent;
        border: none;
        color: #016B7B;
      }  
        @media screen and (max-width:767px) { 
            font-size: 12px;
            line-height: 15px;
        }
      &:active{
        background: transparent;
        border: none;
        color: #016B7B;
        font-size: inherit;
        line-height: inherit;
        vertical-align: inherit;
        margin: 0;
      }  
    }
`;